'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorLink = void 0;
var $ = require("jquery");
var AnchorLink = /** @class */ (function () {
    function AnchorLink() {
        this.scrollSpeed = 550;
        this.scrollEasing = "swing";
        var self = this;
        this.headerHeight = 0; //Number( $('#paramHeaderSpace').outerHeight() ); //ヘッダの高さ
        $('a[href^="#"]').click(function (e) {
            var href = $(this).attr("href");
            e.preventDefault();
            self.scrollToAnchor(href);
            return false;
        });
    }
    AnchorLink.prototype.getAnchorName = function (href) {
        var index = href.indexOf('#');
        return href.slice(index + 1);
    };
    AnchorLink.prototype.scrollToAnchor = function (href) {
        var anchor = this.getAnchorName(href);
        var position = $('#' + anchor).offset().top - this.headerHeight;
        $("html, body").animate({ scrollTop: position }, this.scrollSpeed, this.scrollEasing);
    };
    return AnchorLink;
}());
exports.AnchorLink = AnchorLink;
exports.default = AnchorLink;
